<template>
    <div>
        <!-- <div v-if="updateMode.status">
            {{ updateMode.currentSelected }}
        </div> -->
        <v-select
            dense
            v-model="selectedItem"
            :items="currentEducations"
            :label="placeholder ? placeholder : 'default message'"
            outlined
            rounded
            :rules="required ? requiredRules : noRules"
            :item-text="
                item => (item.name ? capitalizeFirstLetter(item.name) : item.header)
            "
            :item-value="item => item.categoryId"
            @change="setData(selectedItem)"
        >
            <!-- <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item" />
                </template>
                <template v-else>
                    <v-list-item-content>
                        <v-list-item-title
                            v-html="capitalizeFirstLetter(data.item.name)"
                        />
                    </v-list-item-content>
                </template>
            </template> -->
        </v-select>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array
        },
        placeholder: {
            type: String
        },
        setData: {
            type: Function
        },
        required: {
            type: Boolean
        },
        updateMode: {
            type: Object
        }
    },
    computed: {
        currentEducations() {
            const educations = this.items[0] ? this.items[0].educations : [];

            // deconstruct Educations
            const newArr = [];
            educations.forEach(item => {
                newArr.push({
                    header: this.capitalizeFirstLetter(item.name)
                });
                item.categories.forEach(category => {
                    newArr.push(category);
                });
            });
            // console.info(newArr);
            return newArr;
        }
    },
    data() {
        return {
            selectedItem: this.updateMode
                ? this.updateMode.currentSelected
                : "",
            requiredRules: [v => !!v || "Este campo es requerido"],
            noRules: []
        };
    }
};
</script>

<style lang="scss"></style>
